import { render, staticRenderFns } from "./OrderHeadersModal.vue?vue&type=template&id=23e36a3e&scoped=true&"
import script from "./OrderHeadersModal.vue?vue&type=script&lang=js&"
export * from "./OrderHeadersModal.vue?vue&type=script&lang=js&"
import style0 from "./OrderHeadersModal.vue?vue&type=style&index=0&id=23e36a3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e36a3e",
  null
  
)

export default component.exports